module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "colorSet"
    }
  }, [_c('div', {
    staticClass: "colorSet container"
  }, [_c('h4', [_vm._v("颜色管理")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.ColorLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "ColorListPart listPart"
    }, [_c('span', {
      staticStyle: {
        "color": "#333",
        "padding": "3px"
      }
    }, [_vm._v(_vm._s(item.colorName))]), _vm._v(" "), _c('span', {
      staticClass: "colorHint",
      style: ({
        background: item.colorNumber
      })
    }), _vm._v(" "), (_vm.colorAuth.exitColor) ? _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitColor(item, index)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.colorAuth.deleColor) ? _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleColor(item)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.colorAuth.newColor) ? _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newColor()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogColor,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogColor = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('ColorForm')
      }
    }
  }, [_c('el-form', {
    ref: "ColorForm",
    attrs: {
      "model": _vm.ColorForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.ColorFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "颜色名称：",
      "prop": "colorName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "12",
      "placeholder": "请输入颜色名称(不超过12个字)"
    },
    model: {
      value: (_vm.ColorForm.colorName),
      callback: function($$v) {
        _vm.$set(_vm.ColorForm, "colorName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ColorForm.colorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色色号：",
      "prop": "colorNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请准确填写颜色RGB",
      "disabled": true
    },
    model: {
      value: (_vm.ColorForm.colorNumber),
      callback: function($$v) {
        _vm.$set(_vm.ColorForm, "colorNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ColorForm.colorNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-color-picker', {
    model: {
      value: (_vm.ColorForm.colorNumber),
      callback: function($$v) {
        _vm.$set(_vm.ColorForm, "colorNumber", $$v)
      },
      expression: "ColorForm.colorNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('ColorForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('ColorForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('ColorForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-7606f79d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/colorSet.vue
// module id = 1719
// module chunks = 0